<template lang="pug">
#app
  router-view
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { initConsole } from './utils/console'

export default {
  name: 'App',
  created() {
    setInterval(() => {
      this.getDeviceStatus()
    }, 15 * 1000)
  },
  computed: {
    ...mapGetters({
      mac: 'device/mac'
    })
  },
  watch: {
    mac(value) {
      if (value)
        initConsole({
          mac: this.mac,
          appVersion: 'BERG_OS v1.30'
        })
    }
  },
  methods: {
    ...mapActions({
      getDeviceStatus: 'device/getDeviceStatus'
    })
  }
}
</script>

<style lang="scss">
#app {
  height: 100vh;
  width: 100vw;
}
</style>
